export default __webpack_public_path__ + "static/media/Slide-5.58c9ecb0.jpg";